import React from 'react'
// import { RewardFriendModel } from 'models/recruit/RewardListModel'
import { format } from 'date-fns'
import classNames from 'classnames'
import ReactTooltip from 'react-tooltip'
import { Translate } from 'utils/localize'
import { SvgIcon } from 'layouts'
import HexagonFilled from '../../../../../../../recruit-shared/components/hexagon-filled'
import friend from './icons/friend.png'
import accelerator2xEnabled from './icons/accelerator2xEnabled.png'
// import acceleratorDisabled from './icons/acceleratorDisabled.png'
import accelerator4xEnabled from './icons/accelerator4xEnabled.png'
import accelerator4xDisabled from './icons/accelerator4xDisabled.png'
// import plexEnabled from './icons/plexEnabled.png'
// import plexDisabled from './icons/plexDisabled.png'
import omegaEnabled from './icons/omegaEnabled.png'
import omegaDisabled from './icons/omegaDisabled.png'
import style from './Friend.module.scss'

interface Props {
    title: string
    date?: Date
    rewards: Record<string, boolean>
}

interface FriendRewardProps {
    achieved: boolean
    className: string
    src: string
    rewardName: 'accelerator2x' | 'accelerator4x' | 'omega'
    title: React.ReactNode
    tooltipId: string
}

const FriendReward = ({
    achieved,
    // className,
    // src,
    rewardName,
    title,
    tooltipId,
}: FriendRewardProps): JSX.Element => {
    const cx = classNames.bind(style)

    const getRewardCopy = (
        reward: string,
        isAchieved: boolean
    ): JSX.Element => {
        switch (reward) {
            case 'accelerator2x':
                return <span>2x24</span>
            case 'accelerator4x':
                return <span>4x24</span>
            case 'omega':
                return (
                    <span>
                        <SvgIcon
                            width={18}
                            name="omega"
                            fill={isAchieved ? '#fff' : '#101010'}
                        />
                    </span>
                )
            default:
                return <span />
        }
    }

    return (
        <div data-tip={title} data-for={`friend${tooltipId}`}>
            {/* <img className={className} src={src} alt="" /> */}
            <div
                className={cx(style.hexagon, {
                    [style.achieved]: achieved,
                })}
            >
                {getRewardCopy(rewardName, achieved)}
            </div>

            <ReactTooltip
                className={achieved ? style.activetip : style.inactivetip}
                effect="solid"
                aria-haspopup="true"
                id={`friend${tooltipId}`}
            />
        </div>
    )
}

const Friend = ({ title, date, rewards }: Props): JSX.Element => (
    <div className={style.friend}>
        <div className={style.start}>
            <div className={style.hexagonImage}>
                <HexagonFilled light>
                    <img className={style.img} src={friend} alt="" />
                </HexagonFilled>
            </div>
            <div className={style.heading}>
                <div className={style.title}>{title}</div>
                {date && (
                    <div className={style.date}>
                        <Translate id="recruit.recruitedOn">
                            Recruited on
                        </Translate>{' '}
                        {format(new Date(date), 'dd/MM/yy')}
                    </div>
                )}
            </div>
        </div>
        <Translate>
            {({ translate }) => (
                <div className={style.end}>
                    {rewards.FirstPurchase && (
                        <FriendReward
                            achieved
                            className={style.img}
                            src={accelerator2xEnabled}
                            rewardName="accelerator2x"
                            title={translate(
                                'recruit.tooltips.FirstPurchase.enabled'
                            )}
                            tooltipId={`${date}-1`}
                        />
                    )}
                    {rewards.OmegaClonePurchased ? (
                        <FriendReward
                            achieved
                            className={style.img}
                            src={omegaEnabled}
                            rewardName="omega"
                            title={translate(
                                'recruit.tooltips.OmegaClonePurchased.enabled'
                            )}
                            tooltipId={`${date}-2`}
                        />
                    ) : (
                        <FriendReward
                            achieved={false}
                            className={style.img}
                            src={omegaDisabled}
                            rewardName="omega"
                            title={translate(
                                'recruit.tooltips.OmegaClonePurchased.disabled'
                            )}
                            tooltipId={`${date}-2`}
                        />
                    )}
                    {rewards.PlexPurchased ? (
                        <FriendReward
                            achieved
                            className={style.img}
                            src={accelerator4xEnabled}
                            rewardName="accelerator4x"
                            title={translate(
                                'recruit.tooltips.PlexPurchased.enabled'
                            )}
                            tooltipId={`${date}-3`}
                        />
                    ) : (
                        <FriendReward
                            achieved={false}
                            className={style.img}
                            src={accelerator4xDisabled}
                            rewardName="accelerator4x"
                            title={translate(
                                'recruit.tooltips.PlexPurchased.disabled'
                            )}
                            tooltipId={`${date}-3`}
                        />
                    )}
                </div>
            )}
        </Translate>
    </div>
)

Friend.defaultProps = {
    date: undefined,
}

// Friend.propTypes = {
//     title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
//     date: PropTypes.string,
//     rewards: PropTypes.shape({
//         FirstPurchase: PropTypes.bool,
//         OmegaClonePurchased: PropTypes.bool,
//         PlexPurchased: PropTypes.bool,
//     }),
// }

// FriendReward.propTypes = {
//     achieved: PropTypes.bool,
//     className: PropTypes.string,
//     src: PropTypes.string,
//     title: PropTypes.string,
//     tooltipId: PropTypes.string,
// }

export default Friend
